import { makeStyles } from '@mui/styles';
import { Skeleton } from '@mui/material';

const useStyles = makeStyles({
  premiumLoader: {
    backgroundColor: '#5e5e61',
    borderRadius: '5px',
    position: 'relative',
    overflow: 'hidden',
    '&::after': {
      display: 'none !important',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent 20%, rgba(251, 140, 0, 0.4) 45%, rgba(255, 183, 77, 0.8) 50%, rgba(251, 140, 0, 0.4) 55%, transparent 80%)',
      backgroundSize: '200% 100%',
      animation: '$premiumWave 2.2s infinite linear',
    },
  },

  '@keyframes premiumWave': {
    '0%': {
      backgroundPosition: '200% 0',
    },
    '100%': {
      backgroundPosition: '-200% 0',
    },
  },
});

export default function Loader(props) {
  const classes = useStyles();
  const { width } = props;

  return (
    <Skeleton
      variant="text"
      height={20}
      width={width}
      animation={false}
      className={classes.premiumLoader}
    />
  );
}
